import * as React from 'react';
import { t } from '../../helper/locale';
import './OptionsPage.scss';
import { getChromeRuntime } from '../../chrome/wrappers';
import { ChromeMessageType } from '../../types';

export const OptionsPage = () => {
  const [isUploading, setIsUploading] = React.useState(false);
  const [statusMessage, setStatusMessage] = React.useState('');
  const [isSuccess, setIsSuccess] = React.useState(false);

  const handleUploadLogs = async () => {
    try {
      setIsUploading(true);

      const response = await getChromeRuntime().sendMessage({
        type: ChromeMessageType.UPLOAD_LOGS_AND_CLEANUP,
      });

      if (response.success) {
        setStatusMessage(t('Diagnostics successfully uploaded!'));
        setIsSuccess(true);
      } else {
        setStatusMessage(
          t('Diagnostics upload failed! Please try again later.')
        );
        setIsSuccess(false);
      }
    } catch (error) {
      console.error(error);
      setStatusMessage(t('Diagnostics upload failed! Please try again later.'));
      setIsSuccess(false);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="OptionsPage">
      <div className="OptionsPage__actions">
        <button
          className="OptionsPage__upload-button"
          onClick={handleUploadLogs}
          disabled={isUploading}
        >
          {t('Send Diagnostics to Qustodio')}
        </button>
      </div>

      {statusMessage && (
        <div
          className={`OptionsPage__status ${
            isSuccess
              ? 'OptionsPage__status--success'
              : 'OptionsPage__status--error'
          }`}
        >
          {statusMessage}
        </div>
      )}
    </div>
  );
};
